export const DRAWIO_DEFAULT_CONFIGURATION = { compressXml: true };
export const DRAWIO_MENU_CONFIGURATION = {
  disable: {
    menus: ['embed'],
    actions: ['plugins', 'exportUrl'],
  },
};
